module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('b', [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _vm._v("Thank You!")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', [_vm._v("The Bathroom Readers’ Institute thanks the following people whose advice and assistance made this book possible:")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', [_vm._v("Gordon Javna")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("JoAnn Padgett")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Melinda Allman")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Amy Miller")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Jay Newman")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Michael Brunsfeld")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Jeff Altemus")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Angie Kern")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("J. Carroll")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Dan Mansfield")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Chris Stuart")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Scot A. McKibbin")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Maggie McLaughlin")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Stephanie Spadaccini")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("John Dollison")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Sydney Stanley")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("David Cully")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Monica Maestas")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Amy L. and Lisa M.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Ginger Winters")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Jennifer Frederick")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Brian, Thom, and Julia")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("David Calder")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Karen Malchow")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Sophie, J.J., and Bea")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Porter the Wonderdog")])]), _vm._v(" "), _c('p', {
    staticClass: "centerx"
  }, [_c('span', [_c('b', [_vm._v("Uncle John’s Bathroom Reader Wise Up!")]), _vm._v(" is a compilation of running feet and selected articles from the following previously published Bathroom Reader titles: "), _c('i', [_vm._v("Uncle John’s Bathroom Reader Golden Plunger Awards © 2008, Uncle John’s Bathroom Reader Plunges Into Great Lives © 2003, Uncle John’s Bathroom Reader Plunges Into History © 2001, Uncle John’s Bathroom Reader Plunges Into History Again © 2004, Uncle John’s Bathroom Reader Plunges Into Hollywood © 2005, Uncle John’s Bathroom Reader Plunges Into Music © 2007, Uncle John’s Bathroom Reader Plunges Into National Parks © 2007, Uncle John’s Bathroom Reader Plunges Into the Presidency © 2004, Uncle John’s Bathroom Reader Plunges Into Texas © 2004, Uncle John’s Bathroom Reader Takes a Swing at Baseball © 2008, Uncle John’s Bathroom Reader Tees Off on Golf © 2005, Uncle John’s Bathroom Reader Wonderful World of Odd © 2006, Uncle John’s Curiously Compelling Bathroom Reader © 2006, Uncle John’s Fast-Acting Long-Lasting Bathroom Reader © 2005, Uncle John’s Great Big Bathroom Reader © 1998, Uncle John’s Slightly Irregular Bathroom Reader © 2004, Uncle John’s Triumphant 20th Bathroom Reader © 2007.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e09cee5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/thank.vue
// module id = 66
// module chunks = 0